export default __webpack_public_path__ + "static/logo-c06191bcbb03f89f10e905274e8e7021.png";